export const SELECTION_PREVIEW_MOVE_THRESHOLD_PX = 2

export function getSelectionPreviewIntervalMs(durationMs) {
  if (durationMs >= 8) return 48
  if (durationMs >= 5) return 32
  if (durationMs >= 3) return 16
  return 0
}

export function shouldUpdateSelectionPreview(last, next) {
  if (!last) return { update: true, reason: 'initial' }

  const movedEnough = Math.abs(next.sx - last.sx) >= SELECTION_PREVIEW_MOVE_THRESHOLD_PX
    || Math.abs(next.sy - last.sy) >= SELECTION_PREVIEW_MOVE_THRESHOLD_PX
  if (!movedEnough && next.mode === last.mode) return { update: false, reason: 'stationary' }
  if (next.mode !== last.mode) return { update: true, reason: 'mode-change' }

  const intervalMs = last.intervalMs ?? 0
  const elapsedMs = next.now - last.updatedAt
  if (intervalMs > 0 && elapsedMs < intervalMs) {
    return { update: false, reason: 'throttled', retryInMs: intervalMs - elapsedMs }
  }
  return { update: true, reason: 'moved' }
}

export function commitSelectionPreviewUpdate(last, next, durationMs) {
  return {
    sx: next.sx,
    sy: next.sy,
    mode: next.mode,
    updatedAt: next.now,
    intervalMs: getSelectionPreviewIntervalMs(durationMs),
    previousIntervalMs: last?.intervalMs ?? 0,
    lastDurationMs: durationMs,
  }
}
